import React, { useState, useEffect } from 'react';

const SocialLinks = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show when user is near bottom (within 100px of bottom)
      setIsVisible(documentHeight - scrollPosition < 100);
    };

    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const socialLinks = [
    {
      name: 'GitHub',
      url: 'https://github.com/sdpisreddevil',
      icon: 'fab fa-github'
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/sdpbhandari/',
      icon: 'fab fa-linkedin'
    },
    {
      name: 'X',
      url: 'https://x.com/sdp_bhandari',
      icon: "fab fa-x-twitter"
    }
  ];

  return (
    <>
      <div className={`social-links ${isVisible ? 'visible' : ''}`}>
        {socialLinks.map((link, index) => (
          <a 
            key={index}
            href={link.url} 
            target="_blank" 
            rel="noopener noreferrer" 
            title={link.name}
          >
            <i className={link.icon}></i>
          </a>
        ))}
      </div>
      <div className="email-link">
        <a href="mailto:bhandari.sudeep984@gmail.com" className="email-link-text">bhandari.sudeep984@gmail.com</a>
      </div>
    </>
  );
};

export default SocialLinks;